import { Link } from "@msuite/ui/link";
import { useTranslation } from "@msuite/ui/localization";
import type { IncomingInvoicePartnerReport } from "@msuite/utils/types";
import { formatInvoiceAmount } from "@/components/incoming-invoices";

/** Props Interface */
interface IncomingInvoicePartnerReportLinkProps {
	partnerReport: IncomingInvoicePartnerReport;
}

export function IncomingInvoicePartnerReportLink({
	partnerReport,
}: IncomingInvoicePartnerReportLinkProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Computed */
	// `partner_reports.week` is `GGGG-WW`; the report printed it as "KW WW/GGGG".
	const [year, week] = partnerReport.week.split("-");

	/** Render */
	return (
		<div className="v-stack items-start gap-0">
			<Link href={`/partners/${partnerReport.partnerOrgId}`}>
				{partnerReport.partnerName ?? partnerReport.partnerOrgId}
			</Link>
			<span className="label">
				{t("incoming_invoices.partner_report_summary", {
					week: `${week}/${year}`,
					total: formatInvoiceAmount(partnerReport.total, "EUR"),
				})}
			</span>
		</div>
	);
}
